import React, { Component } from 'react'
import JewelryPanel from '../../jewelry-panel'
import Spacer from '../../../../components/spacer'
import SelectItem from '../../../../components/select-item'
import {
  showBailPanel,
  hideBailDiamondMilgrain
} from '../../../../utils/jewelry-validation'

class BailDiamondPanel extends Component {
  render () {
    const props = this.props

    const getBailDiamondShapeOptions = () => {
      let options = [
        { value: 'round_shape', label: 'Round' },
        { value: 'princess', label: 'Princess', disabled: props.bail_type === 'tapered' }
      ]

      return options
    }

    const getBailDiamondSettingStyleOptions = () => {
      let options = [
        { value: 'pave', label: 'Pavé', disabled: props.bail_diamond_shape === 'princess' },
        { value: 'pave_border', label: 'Pavé w/ Border', disabled: props.bail_diamond_shape === 'princess' },
        { value: 'channel_set', label: 'Channel Set' },
        { value: 'bezel_set', label: 'Bezel Set' },
        { value: 'shared_claw_set', label: 'Shared Claw', disabled: props.bail_diamond_shape === 'princess' }
      ]

      return options
    }

    return (
      <JewelryPanel
        id='bail_diamond_panel_container'
        show={showBailPanel(props)}
        isResetting={props.isResetting}>

        <Spacer xxs />

        <SelectItem
          id='has_bail_diamond'
          label='Diamonds on Bail?'
          labelId='bailDiamond'
          options={[
            {value: false, label: 'No'},
            {value: true, label: 'Yes'}
          ]}
          value={props.has_bail_diamond}
          onChange={props.onChangeVal.bind(this, 'has_bail_diamond')}
          initVal={null}
        />
        <JewelryPanel
          id='bail_diamond_panel'
          show={props.has_bail_diamond}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <SelectItem
            id='bail_diamond_shape'
            label='Shape of Diamonds on Bail'
            labelId='bailDiamondShape'
            options={getBailDiamondShapeOptions()}
            value={props.bail_diamond_shape}
            onChange={props.onChangeVal.bind(this, 'bail_diamond_shape')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='quality_of_bail_diamond'
            label='Quality of Diamonds on Bail'
            labelId='bailDiamondQuality'
            options={[
              {value: 'standard', label: 'Standard'},
              {value: 'plus', label: 'Plus'},
              {value: 'lab_grown', label: 'Lab Grown'},
            ]}
            value={props.bail_diamond_quality}
            onChange={props.onChangeVal.bind(this, 'bail_diamond_quality')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='bail_diamond_setting_style'
            label='Setting Style of Diamonds on Bail'
            labelId='bailDiamondSettingStyle'
            options={getBailDiamondSettingStyleOptions()}
            value={props.bail_diamond_setting_style}
            onChange={props.onChangeVal.bind(this, 'bail_diamond_setting_style')}
            initVal={null}
          />

          <Spacer xxs hide={hideBailDiamondMilgrain(props)} />

          <SelectItem
            id='bail_diamond_milgrain'
            label='Milgrain Bail'
            labelId='bailDiamondMilgrain'
            options={[
              {value: 'no', label: 'No'},
              {value: 'yes', label: 'Yes'}
            ]}
            value={props.bail_diamond_milgrain}
            onChange={props.onChangeVal.bind(this, 'bail_diamond_milgrain')}
            hide={hideBailDiamondMilgrain(props)}
            initVal={null}
          />
        </JewelryPanel>
      </JewelryPanel>
    )
  }
}

export default BailDiamondPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/bail-panel/bail-diamond-panel/index.js